import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { Rise } from "@/components/site/Reveal";
import { ATMOSPHERE, TRAILER_SRC } from "@/lib/site";

export const Trailer = () => {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);

  const onPlay = () => {
    if (!TRAILER_SRC) return;
    setPlaying(true);
    setTimeout(() => videoRef.current && videoRef.current.play(), 50);
  };

  return (
    <section
      id="trailer"
      data-testid="trailer-section"
      className="relative bg-ink-pure py-28 sm:py-40"
    >
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10">
        <div className="mb-12 sm:mb-16 max-w-4xl">
          <p className="font-sans text-xs uppercase tracking-[0.4em] text-rust mb-6">
            The official book trailer
          </p>
          <h2 className="font-serif uppercase leading-[0.92] tracking-tight text-bone text-4xl sm:text-6xl lg:text-7xl">
            This was never about the motorcycle.
          </h2>
        </div>

        <Rise>
          <div
            className="group relative w-full overflow-hidden border border-bone/15"
            style={{ aspectRatio: "16 / 9" }}
            data-testid="trailer-player"
          >
            {playing && TRAILER_SRC ? (
              <video
                ref={videoRef}
                src={TRAILER_SRC}
                controls
                playsInline
                className="h-full w-full object-cover bg-black"
                data-testid="trailer-video"
              />
            ) : (
              <>
                <div
                  className="absolute inset-0 mono bg-cover bg-center scale-105 transition-transform duration-1000 group-hover:scale-110"
                  style={{ backgroundImage: `url(${ATMOSPHERE.trailerPoster})` }}
                  aria-hidden="true"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-pure via-ink-pure/40 to-ink-pure/20" />

                <button
                  onClick={onPlay}
                  data-testid="trailer-play-button"
                  aria-label="Play book trailer"
                  className="absolute inset-0 flex flex-col items-center justify-center gap-6 focus:outline-none"
                >
                  <motion.span
                    whileHover={{ scale: 1.06 }}
                    transition={{ duration: 0.4 }}
                    className="flex h-20 w-20 sm:h-24 sm:w-24 items-center justify-center border border-bone/70 bg-ink/30 backdrop-blur-sm"
                  >
                    <Play
                      className="h-7 w-7 sm:h-8 sm:w-8 text-bone ml-1"
                      strokeWidth={1}
                      fill="currentColor"
                    />
                  </motion.span>
                  <span className="font-sans text-[0.65rem] uppercase tracking-[0.4em] text-bone-soft">
                    Trailer arriving soon
                  </span>
                </button>

                <span className="absolute bottom-5 left-6 font-serif italic text-bone-muted text-sm">
                  Women Who Don’t Sit Still · official trailer
                </span>
              </>
            )}
          </div>
        </Rise>

        <Rise delay={0.15}>
          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 font-serif uppercase tracking-tight text-bone-muted text-lg sm:text-2xl">
            <span>No plan.</span>
            <span>No guarantees.</span>
            <span>No perfect moment.</span>
            <span className="text-bone">Just a decision.</span>
          </div>
        </Rise>
      </div>
    </section>
  );
};
